import { useState } from "react";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import "./settings.scss";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Avatar } from 'primereact/avatar';
import AvatarPhoto from './avatar.svg'
import { Button } from "primereact/button";
import { auth0ChangePassword } from "features/authentication/authSlices";
interface GeneralFormProps{
  name: string;
  email: string;
}
interface ChangePasswordFormProps{
  password: string;
  newPassword: string;
  confirmNewPassword: string;
}
const Settings = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const generalFormik = useFormik<GeneralFormProps>({
    initialValues: {
      name: user.name,
      email: user.email
    },
    validateOnMount: true,
    onSubmit: ({ name, email }) => {
      // dispatch
    }
  });
  const changePasswordFormik = useFormik<ChangePasswordFormProps>({
    initialValues: {
      password: '',
      newPassword: '',
      confirmNewPassword: ''
    },
    validateOnMount: true,
    onSubmit: ({ password, newPassword, confirmNewPassword}) => {
      dispatch(auth0ChangePassword(user.email, password, newPassword))
    }
  });
  const handleImageChange = (e: any) =>{
    console.log(e.target.value)
  }
  const handleControls = (save: boolean)=>{
    if(save){
      if(generalFormik.dirty){
        generalFormik.handleSubmit()
        generalFormik.resetForm()
      }
      if(changePasswordFormik.dirty){
        changePasswordFormik.handleSubmit()
    }
  }
    else {
      console.log('Cancel')
    }
  }
 return (
    <div className='settings'>
        <PageHierarchy />
        <div className="settings__photo-section">
        <div className="settings__photo-section__titles">
          <div className="settings__photo-section__titles__primary">
            Your photo
          </div>
          <div className="settings__photo-section__titles__secondary">
            This will be displayed on your profile. 
          </div>
          </div>
          <div className="settings__photo-section__photo">
            <Avatar image={user.picture} shape="circle" className="settings__photo-section__photo" />
          </div>
          <div className="settings__photo-section__controls">
            <div className="settings__photo-section__controls">

            </div>
            <div className="settings__photo-section__controls">
              <div className="settings__photo-section__controls__delete">
                Delete
              </div>
              <div className="settings__photo-section__controls__update" onClick={() => document.getElementById('imageInput').click()}>
                Update
                <input
                  id="imageInput"
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleImageChange}
                />
              </div>
              
            </div>
          </div>
        </div>
        <div className="settings__separator"></div>
        <div className="settings__form-section">
          <div className="settings__form-section__title">General</div>
          <div className="settings__form-section__row">
              <label htmlFor="name" className='input-label'>{'Name'}</label>
              <InputText id="name" value={generalFormik.values.name} type='string' name={'name'} onChange={generalFormik.handleChange} className='text-input' />
          </div>
          <div className="settings__form-section__row">
              <label htmlFor="email" className='input-label'>{'Email'}</label>
              <InputText id="email" value={generalFormik.values.email} type='string' name={'email'} onChange={generalFormik.handleChange} className='text-input' />
          </div>  
        </div>
        <div className="settings__separator"></div>
        <div className="settings__form-section">
          <div className="settings__form-section__title">Change password</div>
          <div className="settings__form-section__row">
              <label htmlFor="password" className='input-label'>{'Current Password'}</label>
              <InputText id="password" type='password' name={'password'} onChange={changePasswordFormik.handleChange} className='text-input' />
          </div>
          <div className="settings__form-section__row">
              <label htmlFor="newPassword" className='input-label'>{'New Password'}</label>
              <InputText id="newPassword" type='password' name={'newPassword'} onChange={changePasswordFormik.handleChange} className='text-input' />
          </div>
          <div className="settings__form-section__row">
              <label htmlFor="confirmNewPassword" className='input-label'>{'Confirm Password'}</label>
              <InputText id="confirmNewPassword" type='password' name={'confirmNewPassword'} onChange={changePasswordFormik.handleChange} className='text-input' />
          </div>
        </div>
        <div className="settings__controls">
          <Button onClick={() => handleControls(false)}  label={'Cancel'} className="settings__controls__cancel" />
          <Button onClick={() =>  handleControls(true)} label={'Save settings'} className="settings__controls__save" />  
        </div>
      </div>
  );
};

export default Settings;
